/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Tolerance_HelpInputs */

const en_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerance for start points in seconds`)
};

const fr_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolérance pour les points de début en secondes`)
};

const de_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toleranz für Startpunkte in Sekunden`)
};

const it_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolleranza per i punti di partenza in secondi`)
};

const ru_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допуск для начальных точек в секундах`)
};

const es_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerancia para puntos de inicio en segundos`)
};

const zh_cn2_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起始点容差（秒）`)
};

const ja_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始点の許容範囲（秒）`)
};

const hi_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ बिंदुओं के लिए सहनशीलता (सेकंड में)`)
};

const pt_pt2_start_tolerance_help = /** @type {(inputs: Start_Tolerance_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerância para pontos de partida em segundos`)
};

/**
* | output |
* | --- |
* | "Tolerance for start points in seconds" |
*
* @param {Start_Tolerance_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const start_tolerance_help = /** @type {((inputs?: Start_Tolerance_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Tolerance_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_start_tolerance_help(inputs)
	if (locale === "de") return de_start_tolerance_help(inputs)
	if (locale === "it") return it_start_tolerance_help(inputs)
	if (locale === "ru") return ru_start_tolerance_help(inputs)
	if (locale === "es") return es_start_tolerance_help(inputs)
	if (locale === "zh-CN") return zh_cn2_start_tolerance_help(inputs)
	if (locale === "ja") return ja_start_tolerance_help(inputs)
	if (locale === "hi") return hi_start_tolerance_help(inputs)
	if (locale === "pt-PT") return pt_pt2_start_tolerance_help(inputs)
	return en_start_tolerance_help(inputs)
});